import { Component } from "react";

// Last line of defence: if anything crashes while rendering, show a dark page with a reload button instead of a blank screen.
export class RootErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { failed: false }; }

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error, info) {
    window.__carioReport?.(`render: ${error?.message}`, "", 0, 0, `${error?.stack || ""}\n${info?.componentStack || ""}`);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const fi = (navigator.language || "").startsWith("fi");
    return (
      <div style={{ minHeight: "100vh", background: "#050507", color: "#e4e4e7", display: "grid", placeItems: "center", padding: 24, fontFamily: "system-ui, sans-serif" }} data-testid="root-error">
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <h1 style={{ color: "#fff", fontSize: 24, marginBottom: 12 }}>{fi ? "Jokin meni vikaan" : "Something went wrong"}</h1>
          <p style={{ color: "#a1a1aa", marginBottom: 24 }}>{fi ? "Virhe on raportoitu meille automaattisesti. Lataa sivu uudelleen." : "We've been notified automatically. Please reload the page."}</p>
          <button type="button" onClick={() => window.location.reload()} data-testid="root-error-reload"
            style={{ background: "#fff", color: "#000", border: 0, borderRadius: 999, padding: "12px 28px", fontWeight: 600 }}>{fi ? "Lataa uudelleen" : "Reload"}</button>
        </div>
      </div>
    );
  }
}
